(function () {
  'use strict';

  var selector = '.fordeer-config-label .fordeer-text-wrap';
  var productCardSelector = '.grid-product, .boost-sd__product-item, .boost-sd__suggestion-queries-item, ' +
    '.boost-sd__quick-view, .cbb-also-bought-product, .ba-product';
  var boostProductDataCache = new WeakMap();

  function readBoostProductData(node) {
    if (!node) return null;

    var raw = node.getAttribute('data-product') || '{}';
    var cached = boostProductDataCache.get(node);
    var product;

    if (cached && cached.raw === raw) return cached.product;

    try {
      product = JSON.parse(raw);
    } catch (error) {
      product = null;
    }

    boostProductDataCache.set(node, { raw: raw, product: product });
    return product;
  }

  function pricingMode() {
    return window.dwMemberPricing?.mode === 'open_sale' ? 'open_sale' : 'members';
  }

  function isClearanceProductData(product) {
    var tags = product && product.tags;

    if (!Array.isArray(tags)) tags = String(tags || '').split(',');

    return tags.some(function (tag) {
      var normalizedTag = String(tag || '').trim().toLowerCase();
      return normalizedTag === 'clearance' || normalizedTag === 'discontinued';
    });
  }

  function markClearanceContext(node) {
    var context = node && node.closest && node.closest(productCardSelector);

    if (!context && node && node.nodeType === 1) context = node;
    if (!context) return;

    if (context.getAttribute('data-dw-clearance-product') !== 'true') {
      context.setAttribute('data-dw-clearance-product', 'true');
    }
    context.querySelectorAll(
      '.grid-product__member-label, .results-products__member-label, ' +
      '.cbb-member-label, .ba-product-member-label, .dw-boost-quick-view-member-badge'
    ).forEach(function (priceLabel) {
      var clearanceText = window.dwMemberPricing?.labels?.clearance || 'CLEARANCE';
      if (priceLabel.textContent !== clearanceText) priceLabel.textContent = clearanceText;
      if (!priceLabel.classList.contains('dw-price-label--clearance')) {
        priceLabel.classList.add('dw-price-label--clearance');
      }
    });
    context.querySelectorAll('.member-price-pdp__note, .dw-boost-quick-view-member-note').forEach(function (note) {
      note.remove();
    });
  }

  function isBestSellingSort(value) {
    return String(value || '').toLowerCase().replace(/[^a-z]/g, '') === 'bestselling' ||
      String(value || '').toLowerCase().replace(/[^a-z]/g, '') === 'bestsellers';
  }

  function blockBestSellingUrl() {
    var url = new URL(window.location.href);
    var replacement = window.location.pathname.indexOf('/search') === 0 ? 'relevance' : 'manual';
    var changed = false;

    Array.from(url.searchParams.entries()).forEach(function (entry) {
      var key = entry[0];
      var value = entry[1];

      if (key.toLowerCase().indexOf('sort') === -1 || !isBestSellingSort(value)) return;

      url.searchParams.set(key, replacement);
      changed = true;
    });

    if (changed) window.location.replace(url.toString());
    return changed;
  }

  if (blockBestSellingUrl()) return;

  function classifyLabel(label) {
    var text = (label.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
    var isStaffPick = text === 'staff pick';
    var isClearance = text === 'clearance' || text === 'discontinued';
    var isApprovedLabel = isStaffPick || isClearance;
    var container = label.closest('.fordeer-config-label');

    label.classList.toggle('dw-staff-pick-label', isStaffPick);
    label.classList.toggle('dw-clearance-label', isClearance);
    label.classList.toggle('dw-product-label--suppressed', !isApprovedLabel);

    if (container) {
      container.classList.toggle('dw-product-label--approved', isApprovedLabel);
      container.classList.toggle('dw-product-label--suppressed', !isApprovedLabel);
      if (isApprovedLabel) {
        if (container.hasAttribute('aria-hidden')) container.removeAttribute('aria-hidden');
      } else if (container.getAttribute('aria-hidden') !== 'true') {
        container.setAttribute('aria-hidden', 'true');
      }
    }

    if (isClearance) markClearanceContext(label);
  }

  function syncClearanceProductData(root) {
    var scope = root || document;
    var nodes = [];

    if (scope.matches && scope.matches('[data-product]')) nodes.push(scope);
    scope.querySelectorAll('[data-product]').forEach(function (node) { nodes.push(node); });

    nodes.forEach(function (node) {
      var product = readBoostProductData(node);

      if (isClearanceProductData(product)) markClearanceContext(node);
    });
  }

  function collectLabels(root, labels, includeDescendants) {
    var scope = root;
    var closestLabel;

    if (!scope) return;
    if (scope.nodeType === 3) scope = scope.parentElement;
    if (!scope || (scope.nodeType !== 1 && scope.nodeType !== 9)) return;

    if (scope.matches && scope.matches(selector)) labels.add(scope);

    closestLabel = scope.closest && scope.closest(selector);
    if (closestLabel) labels.add(closestLabel);

    if (includeDescendants !== false && scope.querySelectorAll) {
      scope.querySelectorAll(selector).forEach(function (label) { labels.add(label); });
    }
  }

  function syncLabels(root) {
    var labels = new Set();

    collectLabels(root || document, labels);
    labels.forEach(classifyLabel);
  }

  function syncMutationLabels(mutations) {
    var labels = new Set();
    var roots = new Set();

    mutations.forEach(function (mutation) {
      var target = mutation.target.nodeType === 3 ? mutation.target.parentElement : mutation.target;
      var card = target && target.nodeType === 1 ? target.closest(productCardSelector) : null;

      collectLabels(target, labels, false);
      if (card) roots.add(card);

      Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
        if (node.nodeType === 1) roots.add(node);
      });
    });

    roots.forEach(function (root) {
      var parent = root.parentElement;

      if (!root.isConnected) return;
      while (parent) {
        if (roots.has(parent)) return;
        parent = parent.parentElement;
      }

      collectLabels(root, labels);
    });

    labels.forEach(classifyLabel);
  }

  function syncSoldOutButtons(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-add-to-cart]').forEach(function (button) {
      var labelNode = button.querySelector('[data-add-to-cart-text]');
      var label = ((labelNode && labelNode.textContent) || button.textContent || '').trim().toLowerCase();

      button.classList.toggle('dw-product-action--sold-out', label === 'sold out');
    });
  }

  function canonicalBoostSearchUrl(targetUrl, preservedSearchTerm) {
    var currentUrl = new URL(window.location.href);
    var nextUrl = new URL(targetUrl || window.location.href, window.location.origin);
    var searchTerm = preservedSearchTerm || currentUrl.searchParams.get('q') ||
      document.querySelector('main input[name="q"]')?.value?.trim();

    if (searchTerm) nextUrl.searchParams.set('q', searchTerm);

    return nextUrl;
  }

  function syncBoostSearchPagination(root) {
    if (window.location.pathname.indexOf('/search') !== 0) return;

    var scope = root || document;

    scope.querySelectorAll('.boost-sd__pagination a[href]').forEach(function (link) {
      var targetUrl = new URL(link.href, window.location.origin);
      var page = targetUrl.searchParams.get('page');
      var canonicalUrl = canonicalBoostSearchUrl(window.location.href);

      canonicalUrl.searchParams.delete('page');
      if (page) canonicalUrl.searchParams.set('page', page);
      link.href = canonicalUrl.pathname + canonicalUrl.search;
    });
  }

  function numericPrice(value) {
    var match = String(value || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return match ? parseFloat(match[0]) : null;
  }

  function syncBoostPricePresentation(root) {
    var pricing = window.dwMemberPricing || {};
    var labels = pricing.labels || {};
    var scope = root || document;
    var selector = '.boost-sd__product-price, .boost-sd__suggestion-queries-item-price, .boost-sd__quick-view-price';
    var prices = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) prices.unshift(scope);
    prices.forEach(function(price) {
      if (price.matches('.boost-sd__suggestion-queries-item-price')) {
        price.querySelectorAll('.boost-sd__format-currency, .boost-sd__format-currency *').forEach(function (amount) {
          if (amount.children.length) return;
          var currentText = amount.textContent;
          var formattedText = currentText.replace(/(\$\s*-?[\d,]+)(?:\.(\d{1,2}))?(?![\d,.])/g, function (match, dollars, cents) {
            return dollars + '.' + (cents || '').padEnd(2, '0');
          });
          if (formattedText === currentText) return;
          amount.textContent = formattedText;
          var label = amount.getAttribute('aria-label');
          if (label) amount.setAttribute('aria-label', label.replace(currentText.trim(), formattedText.trim()));
        });
      }
      var compare = price.querySelector('.boost-sd__format-currency--price-compare');
      var current = price.querySelector('.boost-sd__product-price--sale, .boost-sd__format-currency--price-sale, .boost-sd__product-price--default') ||
        price.querySelector('.boost-sd__format-currency:not(.boost-sd__format-currency--price-compare)');
      if (!current) return;
      var context = price.closest('.boost-sd__product-item, .boost-sd__suggestion-queries-item--product, .boost-sd__quick-view');
      var availabilityCard = context;
      if (context && context.matches('.boost-sd__quick-view')) {
        availabilityCard = Array.prototype.find.call(document.querySelectorAll('.boost-sd__product-item[data-product-id]'), function (item) {
          return item.getAttribute('data-product-id') === context.getAttribute('product-id');
        });
      }
      var productSoldOut = Boolean(context && context.getAttribute('data-dw-product-available') === 'false') ||
        Boolean(availabilityCard && availabilityCard.querySelector('.boost-sd__product-label--soldout, .dw-boost-sold-out'));
      var amount = current.querySelector('.boost-sd__format-currency') || current;
      if (!productSoldOut && price.dataset.dwSoldOutOriginal) {
        if (amount.textContent === price.dataset.dwSoldOutDisplay) amount.textContent = price.dataset.dwSoldOutOriginal;
        delete price.dataset.dwSoldOutOriginal;
        delete price.dataset.dwSoldOutDisplay;
      }
      if (productSoldOut && compare && numericPrice(compare.textContent) > numericPrice(amount.textContent)) {
        if (!price.dataset.dwSoldOutOriginal) price.dataset.dwSoldOutOriginal = amount.textContent;
        var fullPriceText = (/^From\s/i.test(amount.textContent.trim()) ? 'From ' : '') + compare.textContent.trim();
        if (amount.textContent !== fullPriceText) amount.textContent = fullPriceText;
        price.dataset.dwSoldOutDisplay = fullPriceText;
      }
      if (productSoldOut) {
        price.querySelectorAll('.boost-sd__product-price--saving, .dw-boost-quick-view-member-badge, .dw-boost-quick-view-discount').forEach(function (node) {
          node.hidden = true;
        });
        var note = context && context.querySelector('.dw-boost-quick-view-member-note');
        if (note) note.hidden = true;
      }
      var compareCents = Math.round(numericPrice(compare?.textContent) * 100);
      var currentCents = Math.round(numericPrice(current.textContent) * 100);
      var qualifies = compareCents > currentCents && (compareCents - currentCents) * 100 >= compareCents * 2;
      var clearance = Boolean(price.closest('[data-dw-clearance-product="true"]'));
      var standard = productSoldOut || !qualifies && !clearance;
      price.classList.toggle('dw-price-standard', standard);
      price.classList.remove('dw-price-quiet');
      var card = price.closest('.boost-sd__product-item, .boost-sd__suggestion-queries-item--product');
      if (card) card.classList.toggle('dw-product-price-standard', standard);
      if (compare) {
        if (standard && compare.getAttribute('aria-hidden') !== 'true') compare.setAttribute('aria-hidden', 'true');
        if (!standard && compare.hasAttribute('aria-hidden')) compare.removeAttribute('aria-hidden');
      }
      var currentText = current.textContent.trim();
      var priceLabel = standard ? (labels.regularPrice || 'Regular price') :
        clearance ? (labels.clearancePrice || 'Clearance price') :
        pricingMode() === 'open_sale' ? (labels.salePrice || 'Sale price') : (labels.memberPrice || 'Members price');
      var description = priceLabel + ' ' + currentText;
      if (!standard && compare) description = (labels.regularPrice || 'Regular price') + ' ' + compare.textContent.trim() + ', ' + description;
      var accessible = price.querySelector('.boost-sd__visually-hidden');
      if (accessible && accessible.textContent.trim() !== description) accessible.textContent = description;
      current.querySelectorAll('[aria-label]').forEach(function(amount) {
        var value = priceLabel + ': ' + amount.textContent.trim();
        if (amount.getAttribute('aria-label') !== value) amount.setAttribute('aria-label', value);
      });
    });
  }

  function syncBoostAccessiblePriceText(root) {
    var scope = root || document;
    var labels = [];

    if (scope.matches && scope.matches('.boost-sd__visually-hidden')) labels.push(scope);
    scope.querySelectorAll('.boost-sd__visually-hidden').forEach(function (label) {
      labels.push(label);
    });

    labels.forEach(function (label) {
      var text = label.textContent || '';
      var normalizedText = text.replace(/\bsaving\s+Save\s+/gi, 'saving ');

      if (normalizedText !== text) label.textContent = normalizedText;
    });
  }

  function syncBoostCollection(root) {
    var scope = root || document;
    var cards = [];
    var statusLabels = [];
    var sortOptions = [];
    var sortValues = [];
    var swatchGroups = [];

    function friendlySortLabel(text) {
      var labels = {
        'created descending': 'Newest',
        'manual': 'Featured',
        'price ascending': 'Lowest price',
        'price descending': 'Highest price',
        'recommended': 'Featured',
        'relevance': 'Relevance'
      };
      var key = String(text || '').trim().toLowerCase().replace(/[-_]+/g, ' ');

      return labels[key] || text;
    }

    function imageUrlAtWidth(src, width) {
      try {
        var url = new URL(src, window.location.origin);
        url.searchParams.set('width', width);
        return url.toString();
      } catch (error) {
        return src;
      }
    }

    function updateCardImage(card, image, title) {
      var productImage = card.querySelector('.boost-sd__product-image-img--main');
      var widths = [320, 400, 500, 600, 700, 800, 900, 1000, 1200, 1400];

      if (!productImage || !image || !image.src) return;

      productImage.src = imageUrlAtWidth(image.src, 800);
      productImage.srcset = widths.map(function (width) {
        return imageUrlAtWidth(image.src, width) + ' ' + width + 'w';
      }).join(', ');
      productImage.alt = title || productImage.alt;
    }

    function buildNativeSwatches(card) {
      var product;
      var colourOption;
      var info;
      var group;
      var options;

      if (card.querySelector('.boost-sd__product-swatch')) return;

      product = readBoostProductData(card);
      if (!product) return;

      colourOption = (product.options_with_values || []).find(function (option) {
        var name = String(option.original_name || option.name || option.label || '').toLowerCase();
        return name === 'colour' || name === 'color';
      });
      info = card.querySelector('.boost-sd__product-info');

      if (!colourOption || !colourOption.values || colourOption.values.length < 2 || !info) return;

      group = document.createElement('div');
      group.className = 'boost-sd__product-swatch boost-sd__product-swatch--full-width dw-boost-native-swatches';
      group.dataset.dwBoostOwned = 'true';
      options = document.createElement('div');
      options.className = 'boost-sd__product-swatch-options';

      colourOption.values.slice(0, 3).forEach(function (value, index) {
        var imageIndex = Math.max(0, parseInt(value.image || 1, 10) - 1);
        var image = product.images && product.images[imageIndex];
        var option = document.createElement('div');
        var button = document.createElement('button');

        if (!image || !image.src) return;

        option.className = 'boost-sd__product-swatch-option';
        button.className = 'dw-boost-native-swatch';
        button.type = 'button';
        button.title = value.title;
        button.setAttribute('aria-label', 'Colour: ' + value.title);
        button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
        button.style.backgroundImage = 'url("' + imageUrlAtWidth(image.src, 120) + '")';
        button.addEventListener('click', function () {
          options.querySelectorAll('.dw-boost-native-swatch').forEach(function (item) {
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
          updateCardImage(card, image, (card.querySelector('.boost-sd__product-title')?.textContent || '').trim() + ' - ' + value.title);
        });

        option.appendChild(button);
        options.appendChild(option);
      });

      if (!options.children.length) return;

      if (colourOption.values.length > 3) {
        var more = document.createElement('span');
        more.className = 'boost-sd__product-swatch-more';
        more.textContent = '+' + (colourOption.values.length - 3);
        options.appendChild(more);
      }

      group.appendChild(options);
      info.insertBefore(group, info.firstChild);
    }

    if (scope.matches && scope.matches('.boost-sd__sorting-value')) sortValues.push(scope);
    scope.querySelectorAll('.boost-sd__sorting-value').forEach(function (value) { sortValues.push(value); });

    if (sortValues.some(function (value) { return isBestSellingSort(value.textContent); })) {
      var sortUrl = new URL(window.location.href);
      var safeSort = window.location.pathname.indexOf('/search') === 0 ? 'relevance' : 'manual';

      if (sortUrl.searchParams.get('sort') !== safeSort) {
        sortUrl.searchParams.set('sort', safeSort);
        window.location.replace(sortUrl.toString());
        return;
      }

      sortValues.forEach(function (value) {
        var safeLabel = safeSort === 'manual' ? 'Featured' : 'Relevance';

        if (value.textContent !== safeLabel) value.textContent = safeLabel;
      });
    }

    var requestedSort = new URL(window.location.href).searchParams.get('sort') ||
      new URL(window.location.href).searchParams.get('sort_by') ||
      (window.location.pathname.indexOf('/search') === 0 ? 'relevance' : 'manual');

    sortValues.forEach(function (value) {
      var normalizedLabel = friendlySortLabel(value.textContent);

      var nextLabel = String(normalizedLabel || '').trim() || friendlySortLabel(requestedSort);

      if (value.textContent !== nextLabel) value.textContent = nextLabel;
      var sortButton = value.closest('.boost-sd__sorting-button');
      if (sortButton) sortButton.setAttribute('aria-label', 'Sort products: ' + value.textContent);
    });

    if (scope.matches && scope.matches('.boost-sd__sorting-option-item')) sortOptions.push(scope);
    scope.querySelectorAll('.boost-sd__sorting-option-item').forEach(function (option) { sortOptions.push(option); });

    sortOptions.forEach(function (option) {
      var wrapper = option.closest('.boost-sd__sorting-option');

      if (isBestSellingSort(option.textContent) || wrapper?.getAttribute('data-value') === 'best-selling') {
        (wrapper || option).classList.add('dw-boost-hidden-sort');
        (wrapper || option).setAttribute('aria-hidden', 'true');
        option.disabled = true;
        option.tabIndex = -1;
        return;
      }

      var nextOptionLabel = friendlySortLabel(option.textContent);

      if (option.textContent !== nextOptionLabel) option.textContent = nextOptionLabel;
    });

    scope.querySelectorAll('option[value="best-selling"]').forEach(function (option) {
      option.hidden = true;
      option.disabled = true;
    });

    scope.querySelectorAll('.boost-sd__suggestion-queries-header--suggestions').forEach(function (heading) {
      if ((heading.textContent || '').trim().toLowerCase() === 'popular suggestions') {
        heading.textContent = 'Suggested searches';
      }
    });

    scope.querySelectorAll('.boost-sd__instant-search-product-list-header').forEach(function (heading) {
      if ((heading.textContent || '').trim().toLowerCase() === 'products') {
        heading.textContent = 'Top matches';
      }
    });

    if (scope.matches && scope.matches('.boost-sd__product-swatch')) swatchGroups.push(scope);
    scope.querySelectorAll('.boost-sd__product-swatch').forEach(function (group) { swatchGroups.push(group); });

    if (scope.matches && scope.matches('.boost-sd__product-item')) cards.push(scope);
    scope.querySelectorAll('.boost-sd__product-item').forEach(function (card) { cards.push(card); });

    if (scope.matches && scope.matches('[class*="badge"], [class*="label"], [class*="sold"]')) statusLabels.push(scope);
    scope.querySelectorAll(
      '.boost-sd__product-item [class*="badge"], ' +
      '.boost-sd__product-item [class*="label"], ' +
      '.boost-sd__product-item [class*="sold"], ' +
      '.boost-sd__instant-search-results [class*="badge"], ' +
      '.boost-sd__instant-search-results [class*="label"], ' +
      '.boost-sd__instant-search-results [class*="sold"]'
    ).forEach(function (label) { statusLabels.push(label); });

    cards.forEach(buildNativeSwatches);

    statusLabels.forEach(function (label) {
      if ((label.textContent || '').trim().toLowerCase() === 'sold out') {
        var outerLabel = label.closest('.boost-sd__product-label, .boost-sd__suggestion-queries-item-badge');

        if (outerLabel && outerLabel !== label) {
          label.classList.remove('dw-boost-sold-out');
          outerLabel.classList.add('dw-boost-sold-out');
          return;
        }

        label.classList.add('dw-boost-sold-out');
      }
    });

    swatchGroups.forEach(function (group) {
      var options = group.querySelectorAll('.boost-sd__product-swatch-option');
      var more = group.querySelector('.boost-sd__product-swatch-more');

      if (!more || options.length <= 3 || more.dataset.dwCountAdjusted === 'true') return;

      var hiddenCount = parseInt((more.textContent || '').replace(/\D/g, ''), 10);
      if (!isNaN(hiddenCount)) more.textContent = '+' + (hiddenCount + options.length - 3);
      more.dataset.dwCountAdjusted = 'true';
    });

  }

  function syncBoostNoResults(root) {
    var scope = root || document;
    var pages = [];
    var searches = [
      ['Tents', 'tent'],
      ['Sleeping bags', 'sleeping bag'],
      ['Gazebos', 'gazebo'],
      ['Headlamps', 'headlamp'],
      ['Sleeping mats', 'sleeping mat'],
      ['Backpacks', 'backpack'],
      ['Hiking poles', 'hiking poles'],
      ['Rain jackets', 'rain jacket']
    ];

    if (scope.matches && scope.matches('.boost-sd__no-search-result-page')) pages.push(scope);
    scope.querySelectorAll('.boost-sd__no-search-result-page').forEach(function (page) {
      pages.push(page);
    });

    pages.forEach(function (page) {
      var list = page.querySelector('.boost-sd__no-search-result-page-suggestion-list');
      var suggestionSection = page.querySelector('.boost-sd__no-search-result-page-search-term-suggestion');

      if (list && !list.children.length) {
        searches.forEach(function (search) {
          var item = document.createElement('li');
          var link = document.createElement('a');

          link.href = '/search?q=' + encodeURIComponent(search[1]);
          link.textContent = search[0];
          item.appendChild(link);
          list.appendChild(item);
        });
      }

      if (suggestionSection && !page.querySelector('.dw-search-no-results-help')) {
        var help = document.createElement('div');
        var copy = document.createElement('p');
        var helpLink = document.createElement('a');

        help.className = 'dw-search-no-results-help';
        help.dataset.dwBoostOwned = 'true';
        copy.textContent = "Can't find what you need? Our team can help narrow it down.";
        helpLink.href = '/pages/contact-us';
        helpLink.textContent = 'Ask our team';
        help.appendChild(copy);
        help.appendChild(helpLink);
        suggestionSection.insertAdjacentElement('afterend', help);
      }
    });
  }

  var boostQuickViewProductRequests = {};

  function loadBoostQuickViewProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (boostQuickViewProductRequests[handle]) return boostQuickViewProductRequests[handle];

    var root = window.Shopify?.routes?.root || '/';
    boostQuickViewProductRequests[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load variant availability');
      return response.json();
    }).catch(function () {
      return null;
    });

    return boostQuickViewProductRequests[handle];
  }

  function syncBoostQuickViewAvailability(quickView, product) {
    if (!quickView || !product?.variants?.length) return;

    var groups = Array.prototype.slice.call(quickView.querySelectorAll('.boost-sd__product-swatch'));
    var optionNames = (product.options || []).map(function (option) {
      return String(option.name || option).trim().toLowerCase();
    });
    var selections = {};

    groups.forEach(function (group, groupIndex) {
      var title = group.querySelector('.boost-sd__product-swatch-title');
      var name = String(title?.textContent || '').split('—')[0].trim().toLowerCase();
      var optionIndex = optionNames.indexOf(name);
      var selected = group.querySelector('.boost-sd__radio-label--selected');

      if (optionIndex === -1 && name === 'colour') optionIndex = optionNames.indexOf('color');
      if (optionIndex === -1 && name === 'color') optionIndex = optionNames.indexOf('colour');
      if (optionIndex === -1) optionIndex = groupIndex;

      group.dataset.dwVariantOptionIndex = String(optionIndex);
      if (selected) selections[optionIndex] = selected.getAttribute('data-swatch-value') || selected.textContent.trim();
    });

    groups.forEach(function (group) {
      var optionIndex = parseInt(group.dataset.dwVariantOptionIndex, 10);

      group.querySelectorAll('.boost-sd__radio-label').forEach(function (label) {
        var value = label.getAttribute('data-swatch-value') || label.textContent.trim();
        var candidateSelections = Object.assign({}, selections, { [optionIndex]: value });
        var available = product.variants.some(function (variant) {
          if (!variant.available) return false;

          return Object.keys(candidateSelections).every(function (key) {
            return String(variant.options[Number(key)]) === String(candidateSelections[key]);
          });
        });
        var baseAriaLabel = label.dataset.dwBaseAriaLabel || label.getAttribute('aria-label') || value;
        var baseTitle = label.dataset.dwBaseTitle || label.getAttribute('title') || value;

        label.dataset.dwBaseAriaLabel = baseAriaLabel.replace(/, sold out$/i, '');
        label.dataset.dwBaseTitle = baseTitle.replace(/ - sold out$/i, '');
        label.classList.toggle('boost-sd__radio-label--sold-out', !available);
        label.toggleAttribute('data-sold-out', !available);
        label.setAttribute('aria-label', label.dataset.dwBaseAriaLabel + (available ? '' : ', sold out'));
        label.setAttribute('title', label.dataset.dwBaseTitle + (available ? '' : ' - sold out'));
      });
    });
  }

  function syncBoostQuickView(root) {
    var scope = root || document;
    var quickViews = [];

    function imageUrlAtWidth(src, width) {
      try {
        var url = new URL(src, window.location.origin);
        url.searchParams.set('width', width);
        return url.toString();
      } catch (error) {
        return src;
      }
    }

    function syncOptionSelectors(quickView) {
      var productId = quickView.getAttribute('product-id');
      var productCard = Array.prototype.find.call(
        document.querySelectorAll('.boost-sd__product-item[data-product-id]'),
        function (card) { return card.getAttribute('data-product-id') === productId; }
      );
      var product;
      var colourOption;

      product = readBoostProductData(productCard) || {};

      colourOption = (product.options_with_values || []).find(function (option) {
        var name = String(option.original_name || option.name || option.label || '').toLowerCase();
        return name === 'colour' || name === 'color';
      });

      quickView.querySelectorAll('.boost-sd__product-swatch').forEach(function (group) {
        var title = group.querySelector('.boost-sd__product-swatch-title');
        var titleText = String(title?.textContent || '').split('—')[0].trim().toLowerCase();
        var labels = Array.prototype.slice.call(group.querySelectorAll('.boost-sd__radio-label'));
        var isColour = titleText === 'colour' || titleText === 'color';
        var selected;

        group.classList.toggle('dw-boost-quick-view-swatch--colour', isColour);
        group.classList.toggle('dw-boost-quick-view-swatch--size', titleText === 'size');

        if (!isColour) return;

        selected = group.querySelector('.boost-sd__radio-label--selected') || labels[0];
        if (title) {
          var selectedTitle = 'Colour' + (selected ? ' — ' + selected.textContent.trim() : '');

          if (title.textContent !== selectedTitle) title.textContent = selectedTitle;
        }

        labels.forEach(function (label) {
          var value = label.getAttribute('data-swatch-value') || label.textContent.trim();
          var optionValue = colourOption?.values?.find(function (item) {
            return String(item.title || '').toLowerCase() === String(value).toLowerCase();
          });
          var imageIndex = Math.max(0, parseInt(optionValue?.image || 0, 10) - 1);
          var image = optionValue?.image ? product.images?.[imageIndex] : null;
          var hasBoostImage = label.classList.contains('boost-sd__radio-label--hide-text') ||
            Boolean(label.style.backgroundImage);

          if (image?.src) {
            label.style.backgroundImage = 'url("' + imageUrlAtWidth(image.src, 120) + '")';
          }

          if (image?.src || hasBoostImage) {
            label.classList.add('dw-boost-quick-view-image-swatch');
            label.title = value;
          }

          if (label.dataset.dwColourTitleBound !== 'true') {
            label.addEventListener('click', function () {
              window.requestAnimationFrame(function () {
                if (title) title.textContent = 'Colour — ' + value;
              });
            });
            label.dataset.dwColourTitleBound = 'true';
          }
        });
      });
    }

    if (scope.matches && scope.matches('.boost-sd__quick-view')) quickViews.push(scope);
    scope.querySelectorAll('.boost-sd__quick-view').forEach(function (quickView) {
      quickViews.push(quickView);
    });

    quickViews.forEach(function (quickView) {
      var price = quickView.querySelector('.boost-sd__quick-view-price');
      price?.querySelectorAll('.boost-sd__format-currency').forEach(function (amount) {
        if (amount.children.length) return;
        var currentText = amount.textContent;
        var formattedText = currentText.replace(/(\$\s*-?[\d,]+)(?:\.(\d{1,2}))?(?![\d,.])/g, function (match, dollars, cents) {
          return dollars + '.' + (cents || '').padEnd(2, '0');
        });
        if (formattedText !== currentText) amount.textContent = formattedText;
      });
      var compare = price?.querySelector('.boost-sd__format-currency--price-compare');
      var current = price?.querySelector('.boost-sd__format-currency:not(.boost-sd__format-currency--price-compare)');
      var memberBadge = price?.querySelector('.dw-boost-quick-view-member-badge');
      var discount = price?.querySelector('.dw-boost-quick-view-discount');
      var memberNote = quickView.querySelector('.dw-boost-quick-view-member-note');
      var rating = quickView.querySelector('.dw-boost-quick-view-rating');
      var detailsLink = quickView.querySelector('.boost-sd__quick-view-details-link');
      var productHandle = '';
      var productCard;
      var cardProduct;
      var isClearanceProduct = false;
      var compareValue = numericPrice(compare?.textContent);
      var currentValue = numericPrice(current?.textContent);
      var hasMemberPrice = Boolean(compareValue && currentValue && currentValue < compareValue &&
        (Math.round(compareValue * 100) - Math.round(currentValue * 100)) * 100 >= Math.round(compareValue * 100) * 2);

      if (detailsLink) {
        try {
          productHandle = new URL(detailsLink.href, window.location.origin).pathname
            .replace(/^\/products\//, '')
            .split('/')[0];
        } catch (error) {
          productHandle = '';
        }
      }

      productCard = Array.prototype.find.call(
        document.querySelectorAll('.boost-sd__product-item[data-product-id]'),
        function (card) { return card.getAttribute('data-product-id') === quickView.getAttribute('product-id'); }
      );
      cardProduct = readBoostProductData(productCard);
      isClearanceProduct = isClearanceProductData(cardProduct) ||
        productCard?.getAttribute('data-dw-clearance-product') === 'true' ||
        quickView.getAttribute('data-dw-clearance-product') === 'true';
      if (isClearanceProduct) markClearanceContext(quickView);

      quickView.classList.add('dw-boost-quick-view');
      syncOptionSelectors(quickView);
      loadBoostQuickViewProduct(productHandle).then(function (fullProduct) {
        syncBoostQuickViewAvailability(quickView, fullProduct);
        if (fullProduct && typeof fullProduct.available === 'boolean') {
          var availability = String(fullProduct.available);
          if (quickView.getAttribute('data-dw-product-available') !== availability) {
            quickView.setAttribute('data-dw-product-available', availability);
            scheduleBoostSync(quickView);
          }
        }
        if (!isClearanceProductData(fullProduct)) return;

        if (quickView.getAttribute('data-dw-clearance-product') !== 'true') {
          markClearanceContext(quickView);
          scheduleBoostSync(quickView);
        }
      });

      if (detailsLink && detailsLink.textContent.trim() !== 'View full product details') {
        detailsLink.textContent = 'View full product details';
        detailsLink.setAttribute('aria-label', 'View full product details');
      }

      if (!rating && detailsLink) {
        var productPath;

        try {
          productPath = new URL(detailsLink.href, window.location.origin).pathname;
        } catch (error) {
          productPath = '';
        }

        var matchingCard = Array.prototype.find.call(
          document.querySelectorAll('.boost-sd__product-item'),
          function (card) {
            var productLink = card.querySelector('a.boost-sd__product-link[href]');

            if (!productLink) return false;

            try {
              return new URL(productLink.href, window.location.origin).pathname === productPath;
            } catch (error) {
              return false;
            }
          }
        );
        var sourceRating = matchingCard?.querySelector('.boost-sd__product-rating .okeReviews');

        if (sourceRating) {
          rating = document.createElement('div');
          rating.className = 'dw-boost-quick-view-rating';
          rating.dataset.dwBoostOwned = 'true';
          rating.appendChild(sourceRating.cloneNode(true));
          price?.insertAdjacentElement('beforebegin', rating);
        }
      }

      if (!price) return;

      var quietPrice = window.dwMemberPricing?.quietMemberPrices && pricingMode() === 'members' &&
        !isClearanceProduct && hasMemberPrice && (compareValue - currentValue) * 100 / compareValue < 2;
      price.classList.toggle('dw-price-quiet', Boolean(quietPrice));
      var hasQualifiedPrice = hasMemberPrice || isClearanceProduct;
      price.classList.toggle('dw-boost-quick-view-price--member', hasQualifiedPrice);

      if (!hasQualifiedPrice) {
        memberBadge?.remove();
        discount?.remove();
        memberNote?.remove();
        return;
      }

      if (!memberBadge) {
        memberBadge = document.createElement('span');
        memberBadge.className = 'dw-boost-quick-view-member-badge';
        memberBadge.dataset.dwBoostOwned = 'true';
        price.appendChild(memberBadge);
      }

      var isOpenSale = pricingMode() === 'open_sale';
      var memberBadgeText = quietPrice ? (window.dwMemberPricing.loggedIn ? window.dwMemberPricing.labels.quietMemberActive : window.dwMemberPricing.labels.quietMember) : isClearanceProduct
        ? (window.dwMemberPricing?.labels?.clearancePrice || 'CLEARANCE')
        : (isOpenSale
          ? (window.dwMemberPricing?.labels?.salePrice || 'SALE PRICE')
          : (window.dwMemberPricing?.loggedIn ? 'MEMBERS PRICE APPLIED' : 'MEMBERS PRICE'));

      if (memberBadge.textContent !== memberBadgeText) memberBadge.textContent = memberBadgeText;

      if (hasMemberPrice && !quietPrice) {
        if (!discount) {
          discount = document.createElement('span');
          discount.className = 'dw-boost-quick-view-discount';
          discount.dataset.dwBoostOwned = 'true';
          price.appendChild(discount);
        }

        var discountText = Math.round(((compareValue - currentValue) * 100) / compareValue) + '% OFF';

        if (discount.textContent !== discountText) discount.textContent = discountText;
      } else {
        discount?.remove();
      }

      if (isOpenSale || isClearanceProduct) {
        memberNote?.remove();
        return;
      }

      if (!memberNote) {
        memberNote = document.createElement('div');
        memberNote.className = 'dw-boost-quick-view-member-note';
        memberNote.dataset.dwBoostOwned = 'true';
        price.insertAdjacentElement('afterend', memberNote);
      }

      if (window.dwMemberPricing?.loggedIn) {
        if (memberNote.dataset.dwState !== 'active') {
          memberNote.textContent = 'Your Members Price is active.';
          memberNote.dataset.dwState = 'active';
        }
        memberNote.classList.add('dw-boost-quick-view-member-note--active');
      } else {
        memberNote.classList.remove('dw-boost-quick-view-member-note--active');
        if (memberNote.dataset.dwState !== (quietPrice ? 'quiet' : 'locked')) {
          memberNote.innerHTML = (quietPrice ? window.dwMemberPricing.quietLoginHtml : window.dwMemberPricing?.loginUnlockHtml) ||
            '<a href="/account/login">Sign up or login for free</a> to access exclusive members deals';
          memberNote.dataset.dwState = quietPrice ? 'quiet' : 'locked';
        }
      }
    });
  }

  var boostSizeCollator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base'
  });
  var boostFootwearScales = Object.create(null);

  function boostFilterKey(filterOption) {
    return (filterOption?.getAttribute('data-filteroptionid') ||
      filterOption?.querySelector('.boost-sd__filter-option-title')?.id.replace(/-toggle$/, '') || '')
      .replace(/::/g, '__');
  }

  function getBoostSizeSortKey(label) {
    var raw = (label || '').trim().replace(/\s+/g, ' ');
    var normalized = raw.toUpperCase().replace(/^#/, '').replace(/\s+/g, '');
    var apparelOrder = {
      '3XS': 0,
      'XXXS': 0,
      '2XS': 1,
      'XXS': 1,
      'XS': 2,
      'EXTRASMALL': 2,
      'S': 3,
      'SMALL': 3,
      'M': 4,
      'MEDIUM': 4,
      'L': 5,
      'LARGE': 5,
      'XL': 6,
      'EXTRALARGE': 6,
      '2XL': 7,
      'XXL': 7,
      '3XL': 8,
      'XXXL': 8,
      '4XL': 9,
      '5XL': 10,
      '6XL': 11
    };
    var wordAliases = {
      'XX-SMALL': '2XS',
      'X-SMALL': 'XS',
      'XX-LARGE': '2XL',
      'X-LARGE': 'XL',
      EXTRASMALL: 'XS',
      SMALL: 'S',
      MEDIUM: 'M',
      LARGE: 'L',
      EXTRALARGE: 'XL'
    };

    Object.keys(wordAliases).forEach(function (word) {
      normalized = normalized.replace(new RegExp(word, 'g'), wordAliases[word]);
    });

    var apparelRange = normalized.match(/^(3XS|XXXS|2XS|XXS|XS|S|M|L|XL|2XL|XXL|3XL|XXXL|4XL|5XL|6XL)[\/-](3XS|XXXS|2XS|XXS|XS|S|M|L|XL|2XL|XXL|3XL|XXXL|4XL|5XL|6XL)$/);
    var footwearSize = normalized.match(/^(EU|UK|US)(\d+(?:\.\d+)?)(?:[\/-](\d+(?:\.\d+)?))?$/);
    var measurement = normalized.match(/^(\d+(?:\.\d+)?)(ML|L|LITRE|LITRES|MM|CM|METRE|METRES|G|KG)$/);
    var numericRange = normalized.match(/^(\d+(?:\.\d+)?)(?:[\/-](\d+(?:\.\d+)?))?/);

    if (Object.prototype.hasOwnProperty.call(apparelOrder, normalized)) {
      return [0, apparelOrder[normalized], 0, raw];
    }

    if (apparelRange) {
      return [
        0,
        (apparelOrder[apparelRange[1]] + apparelOrder[apparelRange[2]]) / 2,
        apparelOrder[apparelRange[2]],
        raw
      ];
    }
    if (footwearSize) {
      return [2, { EU: 0, UK: 1, US: 2 }[footwearSize[1]], parseFloat(footwearSize[2]), raw];
    }
    if (measurement) return [4, parseFloat(measurement[1]), measurement[2], raw];
    if (numericRange) {
      return [
        3,
        parseFloat(numericRange[1]),
        parseFloat(numericRange[2] || numericRange[1]),
        raw
      ];
    }
    if (/^(OS|OSFM|ONESIZE|ONE-SIZE)$/.test(normalized)) return [5, 0, 0, raw];

    return [6, 0, 0, raw];
  }

  function compareBoostSizeKeys(aKey, bKey) {
    var index;

    for (index = 0; index < 3; index += 1) {
      if (aKey[index] === bKey[index]) continue;
      if (typeof aKey[index] === 'number' && typeof bKey[index] === 'number') {
        return aKey[index] - bKey[index];
      }
      return boostSizeCollator.compare(String(aKey[index]), String(bKey[index]));
    }

    return boostSizeCollator.compare(aKey[3], bKey[3]);
  }

  function reorderBoostFilterItems(list, items, sortedItems) {
    var changed = items.some(function (item, index) {
      return item !== sortedItems[index];
    });

    items.forEach(function (item) {
      item.style.removeProperty('order');
    });

    if (!changed) return;

    sortedItems.forEach(function (item) {
      list.appendChild(item);
    });
    if (boostControllerState) boostControllerState.sizeReorders += 1;
  }

  function sortBoostSizeFilters(root) {
    var scope = root || document;

    scope.querySelectorAll('.boost-sd__filter-option').forEach(function (filterOption) {
      // Footwear owns its scale-aware order; sorting the shortened labels here
      // would undo that order and trigger another observer refresh indefinitely.
      if (isFootwearEquivalentFilter(filterOption)) return;

      var title = filterOption.querySelector('.boost-sd__filter-option-title[id^="pf_opt_size"]');
      var filterId = filterOption.getAttribute('data-filteroptionid') || '';
      var heading = (filterOption.querySelector('.boost-sd__filter-option-heading')?.textContent || '').trim();
      var list = filterOption.querySelector('.boost-sd__filter-option-listitem');

      if ((!title && filterId.indexOf('size') === -1 && !/size/i.test(heading)) || !list) return;

      var items = Array.prototype.slice.call(list.children).filter(function (item) {
        return item.querySelector('.boost-sd__filter-option-item-label');
      });

      items.forEach(function (item) {
        var label = item.querySelector('.boost-sd__filter-option-item-label');
        var cleanLabel = (label?.textContent || '').trim().replace(/^#(?=[A-Za-z0-9])/, '');

        if (label && label.textContent.trim() !== cleanLabel) label.textContent = cleanLabel;
      });

      var sortedItems = items.slice().sort(function (a, b) {
        var aLabel = a.querySelector('.boost-sd__filter-option-item-label')?.textContent || '';
        var bLabel = b.querySelector('.boost-sd__filter-option-item-label')?.textContent || '';
        var aKey = getBoostSizeSortKey(aLabel);
        var bKey = getBoostSizeSortKey(bLabel);

        return compareBoostSizeKeys(aKey, bKey);
      });
      list.classList.add('dw-boost-size-list');
      reorderBoostFilterItems(list, items, sortedItems);
    });
  }

  function isFootwearEquivalentFilter(filterOption) {
    var title = filterOption.querySelector('.boost-sd__filter-option-title');
    var heading = filterOption.querySelector('.boost-sd__filter-option-heading');
    var identifier = ((title && title.id) || '').toLowerCase();
    var label = ((heading && heading.textContent) || '').trim().toLowerCase();

    return identifier.indexOf('footwear_size_equivalents') !== -1 ||
      identifier.indexOf('pf_t_footwear_size') !== -1 ||
      label === 'footwear size' ||
      label === 'footwear size equivalents';
  }

  function enhanceFootwearSizeFilters(root) {
    var scope = root || document;

    scope.querySelectorAll('.boost-sd__filter-option').forEach(function (filterOption) {
      var list;
      var items;
      var availableScales;
      var selectedScale;
      var tabs;
      var tabSignature;

      if (!isFootwearEquivalentFilter(filterOption)) return;

      list = filterOption.querySelector('.boost-sd__filter-option-listitem');
      if (!list) return;

      filterOption.classList.add('dw-footwear-size-filter');
      list.classList.add('dw-footwear-size-filter__list');
      items = Array.prototype.slice.call(list.children).filter(function (item) {
        return item.querySelector('.boost-sd__filter-option-item-label');
      });

      items.forEach(function (item) {
        var label = item.querySelector('.boost-sd__filter-option-item-label');
        var rawLabel = item.dataset.dwFootwearRawLabel || (label?.textContent || '').trim();
        var match = rawLabel.match(/^\s*(EU|UK|US)\s+(.+?)\s*$/i);

        if (!match) return;

        item.dataset.dwFootwearRawLabel = rawLabel;
        item.dataset.dwFootwearScale = match[1].toUpperCase();
        item.dataset.dwFootwearSize = match[2];
        item.style.removeProperty('order');
        if (label && label.textContent !== match[2]) label.textContent = match[2];
        // Boost's count is for the exact tag, so it does not describe nearby-size results.
        var amount = item.querySelector('.boost-sd__filter-option-item-amount');
        if (amount && !amount.hidden) amount.hidden = true;
        var choice = item.querySelector('.boost-sd__filter-option-item-button');
        var choiceLabel = 'Find products near ' + match[1].toUpperCase() + ' ' + match[2];
        if (choice && choice.getAttribute('aria-label') !== choiceLabel) choice.setAttribute('aria-label', choiceLabel);
      });

      var sortedItems = items.slice().sort(function (a, b) {
        var scaleOrder = { EU: 0, UK: 1, US: 2 };
        var aScale = scaleOrder[a.dataset.dwFootwearScale] ?? 9;
        var bScale = scaleOrder[b.dataset.dwFootwearScale] ?? 9;

        if (aScale !== bScale) return aScale - bScale;
        return compareBoostSizeKeys(
          getBoostSizeSortKey(a.dataset.dwFootwearSize || ''),
          getBoostSizeSortKey(b.dataset.dwFootwearSize || '')
        );
      });

      reorderBoostFilterItems(list, items, sortedItems);
      items = sortedItems;

      availableScales = ['EU', 'UK', 'US'].filter(function (scale) {
        return items.some(function (item) { return item.dataset.dwFootwearScale === scale; });
      });
      if (!availableScales.length) return;

      selectedScale = boostFootwearScales[boostFilterKey(filterOption)] ||
        filterOption.dataset.dwFootwearScale || items.find(function (item) {
        return item.querySelector('.boost-sd__filter-option-item-button[aria-checked="true"]');
      })?.dataset.dwFootwearScale;
      selectedScale = selectedScale ||
        (availableScales.indexOf('EU') !== -1 ? 'EU' : availableScales[0]);

      tabs = filterOption.querySelector('.dw-footwear-size-filter__tabs');
      if (!tabs) {
        tabs = document.createElement('div');
        tabs.className = 'dw-footwear-size-filter__tabs';
        tabs.dataset.dwBoostOwned = 'true';
        tabs.setAttribute('role', 'tablist');
        tabs.setAttribute('aria-label', 'Footwear size system');
        list.parentNode.insertBefore(tabs, list);
      }

      if (!filterOption.querySelector('.dw-footwear-size-filter__help')) {
        var help = document.createElement('p');
        help.className = 'dw-footwear-size-filter__help';
        help.dataset.dwBoostOwned = 'true';
        help.textContent = 'Includes nearby sizes (±½ size). Check the product size guide for your best fit.';
        help.style.cssText = 'font-size:12px;line-height:1.4;margin:8px 0 12px;color:#56616b';
        list.parentNode.insertBefore(help, list);
      }

      tabSignature = availableScales.map(function (scale) {
        var selectedCount = items.filter(function (item) {
          return item.dataset.dwFootwearScale === scale &&
            Boolean(item.querySelector('.boost-sd__filter-option-item-button[aria-checked="true"]'));
        }).length;

        return scale + ':' + selectedCount;
      }).join('|');

      if (tabs.dataset.dwFootwearSignature !== tabSignature) {
        tabs.innerHTML = '';
        availableScales.forEach(function (scale) {
          var tab = document.createElement('button');
          var selectedCount = items.filter(function (item) {
            return item.dataset.dwFootwearScale === scale &&
              Boolean(item.querySelector('.boost-sd__filter-option-item-button[aria-checked="true"]'));
          }).length;

          tab.className = 'dw-footwear-size-filter__tab';
          tab.type = 'button';
          tab.dataset.dwFootwearScale = scale;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-label', scale + ' sizes' + (selectedCount ? ', ' + selectedCount + ' selected' : ''));
          tab.innerHTML = '<span>' + scale + '</span>' +
            (selectedCount ? '<span class="dw-footwear-size-filter__count">' + selectedCount + '</span>' : '');
          tabs.appendChild(tab);
        });
        tabs.dataset.dwFootwearSignature = tabSignature;
      }

      setFootwearSizeScale(filterOption, availableScales.indexOf(selectedScale) !== -1 ? selectedScale : availableScales[0]);
    });
  }

  function setFootwearSizeScale(filterOption, scale) {
    if (!filterOption || !scale) return;

    filterOption.dataset.dwFootwearScale = scale;
    boostFootwearScales[boostFilterKey(filterOption)] = scale;
    filterOption.querySelectorAll('.dw-footwear-size-filter__list > .boost-sd__filter-option-item').forEach(function (item) {
      item.hidden = item.dataset.dwFootwearScale !== scale;
    });
    filterOption.querySelectorAll('.dw-footwear-size-filter__tab').forEach(function (tab) {
      var isSelected = tab.dataset.dwFootwearScale === scale;

      tab.classList.toggle('is-active', isSelected);
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.tabIndex = isSelected ? 0 : -1;
    });
  }

  function getBoostActiveFilterCount(root) {
    var scope = root || document;
    var selected = new Set();

    scope.querySelectorAll('.boost-sd__filter-option-item-button[aria-checked="true"]').forEach(function (button) {
      var filter = button.closest('.boost-sd__filter-option');
      var filterId = boostFilterKey(filter);
      var value = button.closest('[data-dw-footwear-raw-label]')?.dataset.dwFootwearRawLabel ||
        (button.querySelector('.boost-sd__filter-option-item-label')?.textContent || '').trim();

      if (filterId && value) selected.add(filterId + '\u001f' + value.toLowerCase());
    });

    return selected.size;
  }

  function syncBoostFilterPresentation(root) {
    var scope = root || document;
    var activeFilterCount;

    sortBoostSizeFilters(scope);
    enhanceFootwearSizeFilters(scope);

    scope.querySelectorAll('.boost-sd__filter-tree-vertical-toolbar-middle').forEach(function (title) {
      if (title.textContent !== 'Filters') title.textContent = 'Filters';
    });

    scope.querySelectorAll('.boost-sd__filter-option-search-option').forEach(function (input) {
      var filterId = input.id || '';
      var noun = filterId.indexOf('colour') !== -1 ? 'colours' :
        filterId.indexOf('brand') !== -1 ? 'brands' : 'options';
      var label = 'Search ' + noun;

      if (input.placeholder !== label) input.placeholder = label;
      if (input.getAttribute('aria-label') !== label) input.setAttribute('aria-label', label);
    });

    activeFilterCount = getBoostActiveFilterCount(document);
    document.querySelectorAll('.boost-sd__filter-tree-toggle-button').forEach(function (button) {
      if (activeFilterCount) {
        button.setAttribute('data-dw-active-filter-count', activeFilterCount);
      } else {
        button.removeAttribute('data-dw-active-filter-count');
      }
    });
  }

  function routeMobileQuickViewToProduct(event) {
    if (window.innerWidth > 768) return false;

    var trigger = event.target.closest('.boost-sd__quick-view-btn');

    if (!trigger) return false;

    var card = trigger.closest('.boost-sd__product-item');
    var productLink = card?.querySelector('a.boost-sd__product-link[href]');

    if (!productLink) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(productLink.href);
    return true;
  }

  var boostRootSelector = [
    '.boost-sd-layout',
    '.boost-sd__filter-tree-vertical-sticky-overlay',
    '.boost-sd__instant-search-results',
    '.boost-sd__quick-view',
    '.boost-sd__no-search-result-page'
  ].join(', ');
  var boostControllerState = {
    mutationBatches: 0,
    pendingScopes: [],
    syncFrame: 0,
    syncRuns: 0,
    sizeReorders: 0
  };

  function isThemeOwnedBoostNode(node) {
    if (!node || node.nodeType !== 1) return false;

    return node.matches('[data-dw-boost-owned="true"]') ||
      Boolean(node.closest('[data-dw-boost-owned="true"]'));
  }

  // A published product can have no published variants. Boost may retain that
  // product with a zero price while its index catches up with Shopify.
  var boostCardValidity = new WeakMap();
  var boostBrowseCardSelector = '.boost-sd__product-item, .boost-sd__suggestion-queries-item--product';

  function setBoostCardSuppressed(card, state, suppressed) {
    if (suppressed) {
      card.style.setProperty('display', 'none', 'important');
      card.setAttribute('data-dw-card-validity', state.phase);
    } else {
      if (state.display) card.style.setProperty('display', state.display, state.priority);
      else card.style.removeProperty('display');
      card.setAttribute('data-dw-card-validity', 'valid');
    }
  }

  function restoreBoostCardPrice(card, product) {
    var cents = Number(product.price_min ?? product.price);
    var compareCents = Number(product.compare_at_price_min ?? product.compare_at_price);
    if (!product.available && compareCents > cents) cents = compareCents;
    var money = new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'NZD'
    });
    card.setAttribute('data-dw-product-available', product.available ? 'true' : 'false');
    if (product.available) {
      card.querySelectorAll('.boost-sd__product-label--soldout, .dw-boost-sold-out').forEach(function (label) { label.remove(); });
    }
    card.querySelectorAll('.boost-sd__product-price, .boost-sd__suggestion-queries-item-price').forEach(function (price) {
      var current = price.querySelector('.boost-sd__product-price--sale, .boost-sd__format-currency--price-sale, .boost-sd__product-price--default') ||
        price.querySelector('.boost-sd__format-currency:not(.boost-sd__format-currency--price-compare)');
      var amount = current && (current.querySelector('.boost-sd__format-currency') || current);
      var text = (product.price_varies ? 'From ' : '') + money.format(cents / 100);
      if (amount && amount.textContent !== text) amount.textContent = text;
      var compare = price.querySelector('.boost-sd__format-currency--price-compare');
      var compareText = compareCents > Number(product.price_min ?? product.price) ? money.format(compareCents / 100) : '';
      if (compare && compare.textContent !== compareText) compare.textContent = compareText;
    });
  }

  function syncBoostCardValidity(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll(boostBrowseCardSelector));
    if (root.matches && root.matches(boostBrowseCardSelector)) cards.unshift(root);
    cards.forEach(function (card) {
      var raw = card.getAttribute('data-product') || '';
      var state = boostCardValidity.get(card);
      var data = readBoostProductData(card);
      var price = card.querySelector('.boost-sd__product-price, .boost-sd__suggestion-queries-item-price');
      var displayedZero = numericPrice(price?.textContent) === 0;
      var zero = parseFloat(data?.priceMin) === 0 || displayedZero;
      if (state && state.raw !== raw) {
        setBoostCardSuppressed(card, state, false);
        boostCardValidity.delete(card);
        state = null;
      }
      if (state) {
        if (state.product && displayedZero) restoreBoostCardPrice(card, state.product);
        return;
      }
      if (!zero) return;
      var link = card.querySelector('a[href*="/products/"]');
      var match = link && new URL(link.href, window.location.origin).pathname.match(/\/products\/([^/]+)/);
      var handle = data?.handle || (match && decodeURIComponent(match[1]));
      if (!handle) return;
      state = { raw: raw, phase: 'checking', display: card.style.getPropertyValue('display'), priority: card.style.getPropertyPriority('display') };
      boostCardValidity.set(card, state);
      setBoostCardSuppressed(card, state, true);
      // Reuse the shared request cache; normal, nonzero cards make no request.
      loadBoostQuickViewProduct(handle).then(function (product) {
        if (!card.isConnected || boostCardValidity.get(card) !== state) return;
        if ((card.getAttribute('data-product') || '') !== raw) {
          syncBoostCardValidity(card);
          return;
        }
        if (!product?.variants?.length) {
          state.phase = 'unavailable';
          setBoostCardSuppressed(card, state, true);
          return;
        }
        state.phase = 'valid';
        state.product = product;
        restoreBoostCardPrice(card, product);
        setBoostCardSuppressed(card, state, false);
        scheduleBoostSync(card);
      });
    });
  }

  function syncBoostScope(scope) {
    if (scope !== document && !scope.isConnected) return;

    syncLabels(scope);
    syncClearanceProductData(scope);
    syncSoldOutButtons(scope);
    syncBoostCollection(scope);
    syncBoostNoResults(scope);
    syncBoostQuickView(scope);
    syncBoostFilterPresentation(scope);
    syncBoostSearchPagination(scope);
    syncBoostCardValidity(scope);
    syncBoostAccessiblePriceText(scope);
    syncBoostPricePresentation(scope);
  }

  function scheduleBoostSync(scope) {
    var target = scope || document;
    var existingScopeContainsTarget;

    if (target === document) {
      boostControllerState.pendingScopes = [document];
    } else if (boostControllerState.pendingScopes.indexOf(document) === -1) {
      existingScopeContainsTarget = boostControllerState.pendingScopes.some(function (pendingScope) {
        return pendingScope === target ||
          (pendingScope.contains && pendingScope.contains(target));
      });

      if (!existingScopeContainsTarget) {
        boostControllerState.pendingScopes = boostControllerState.pendingScopes.filter(function (pendingScope) {
          return !(target.contains && target.contains(pendingScope));
        });
        boostControllerState.pendingScopes.push(target);
      }
    }

    if (boostControllerState.syncFrame) return;

    boostControllerState.syncFrame = window.requestAnimationFrame(function () {
      var scopes = boostControllerState.pendingScopes.slice();

      boostControllerState.pendingScopes = [];
      boostControllerState.syncFrame = 0;
      boostControllerState.syncRuns += 1;
      scopes.forEach(syncBoostScope);
      document.documentElement.setAttribute('data-dw-boost-lifecycle', 'ready');
      document.documentElement.setAttribute('data-dw-boost-sync-runs', String(boostControllerState.syncRuns));
    });
  }

  function findBoostScope(node) {
    if (node && node.nodeType === 3) node = node.parentElement;
    if (!node || node.nodeType !== 1 || isThemeOwnedBoostNode(node)) return null;
    if (node.matches(boostRootSelector)) return node;

    var root = node.closest(boostRootSelector);
    if (!root || root.matches('.boost-sd__quick-view')) return root;

    var card = node.closest('.boost-sd__product-item, .boost-sd__suggestion-queries-item--product');
    return card && root.contains(card) ? card : root;
  }

  function collectBoostMutationScopes(mutations) {
    var scopes = new Set();

    mutations.forEach(function (mutation) {
      var targetScope;

      if (isThemeOwnedBoostNode(mutation.target)) return;

      targetScope = findBoostScope(mutation.target);
      if (targetScope) scopes.add(targetScope);

      Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
        var nodeScope;

        if (node.nodeType !== 1 || isThemeOwnedBoostNode(node)) return;

        nodeScope = findBoostScope(node);
        if (nodeScope) scopes.add(nodeScope);
        node.querySelectorAll(boostRootSelector).forEach(function (root) {
          scopes.add(root);
        });
      });
    });

    return Array.from(scopes).filter(function (scope, index, allScopes) {
      return !allScopes.some(function (otherScope) {
        return otherScope !== scope && otherScope.contains(scope);
      });
    });
  }

  function handleBoostDocumentClick(event) {
    var footwearTab = event.target.closest('.dw-footwear-size-filter__tab');

    if (footwearTab) {
      setFootwearSizeScale(
        footwearTab.closest('.dw-footwear-size-filter'),
        footwearTab.dataset.dwFootwearScale
      );
      scheduleBoostSync(footwearTab.closest(boostRootSelector) || document);
    }

    routeMobileQuickViewToProduct(event);
  }

  function startBoostPresentation() {
    if (window.DwightsBoostPresentation) {
      window.DwightsBoostPresentation.refresh();
      return;
    }

    var boostObserver = new MutationObserver(function (mutations) {
      var scopes = collectBoostMutationScopes(mutations);

      syncMutationLabels(mutations);
      if (!scopes.length) return;

      boostControllerState.mutationBatches += 1;
      scopes.forEach(scheduleBoostSync);
    });

    window.DwightsBoostPresentation = {
      version: '6.3.1',
      refresh: function () {
        scheduleBoostSync(document);
      },
      diagnostics: function () {
        return {
          mutationBatches: boostControllerState.mutationBatches,
          pendingScopes: boostControllerState.pendingScopes.length,
          sizeReorders: boostControllerState.sizeReorders,
          syncRuns: boostControllerState.syncRuns
        };
      }
    };

    scheduleBoostSync(document);
    boostObserver.observe(document.body, {
      attributeFilter: ['aria-checked', 'data-product'],
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    var lastViewportWidth = window.innerWidth;
    var lastViewportMode = window.innerWidth <= 768 ? 'mobile' : 'desktop';

    window.addEventListener('resize', function () {
      var currentWidth = window.innerWidth;
      var currentMode = currentWidth <= 768 ? 'mobile' : 'desktop';

      if (currentMode !== lastViewportMode || Math.abs(currentWidth - lastViewportWidth) > 8) {
        lastViewportWidth = currentWidth;
        lastViewportMode = currentMode;
        scheduleBoostSync(document);
      }
    });
    window.addEventListener('pageshow', function () { scheduleBoostSync(document); });
    window.addEventListener('popstate', function () { scheduleBoostSync(document); });
    document.addEventListener('click', handleBoostDocumentClick, true);

  }

  if (document.body) {
    startBoostPresentation();
  } else {
    document.addEventListener('DOMContentLoaded', startBoostPresentation, { once: true });
  }
}());
